import { render, staticRenderFns } from "./step-customer.vue?vue&type=template&id=4721760b&"
import script from "./step-customer.vue?vue&type=script&lang=js&"
export * from "./step-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports